module.exports = "/assets/storybook/reservation-card-3-2.jpg?unSJG18";